import React from 'react'
import MModal from '@mui/material/Modal'
import Box from './Box';

const defaultStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    p: { xs: 0, md: 6 },
    outline: 'none',
    borderRadius: '8px',
    maxWidth: '90vw',
    // maxHeight: '90vh',
    overflow: 'auto',
    width: { xs: '100%', sm: 400, md: 750 },
}

export const Modal = ({
    open, 
    onClose, 
    children, 
    sx = {}, 
    disableBackdropClick = false,
    disableEscapeKeyDown = false,
    ...props
}) => {
    const handleClose = (event, reason) => {
        if (onClose) {
            onClose(event, reason);
        }
    };

    const combinedStyle = {
        ...defaultStyle,
        ...sx
    };

    return (
        <MModal 
            {...props} 
            open={open} 
            onClose={handleClose}
            disableBackdropClick={disableBackdropClick}
            disableEscapeKeyDown={disableEscapeKeyDown}
        >
            <Box sx={combinedStyle}>
                {children}
            </Box>
        </MModal>
    )
}

export default React.memo(Modal);